import { forwardRef, ReactNode } from 'react';
import { FeaturesContainer, Header } from './components';
import {
  StyledBackgroundImageContainer,
  StyledContainer,
  StyledDisitributionInfoContainer,
} from './styled';

interface DistributionInfoProps {
  customFooter?: ReactNode;
}

const DistributionInfo = forwardRef<HTMLDivElement, DistributionInfoProps>(
  ({ customFooter }, ref) => {
    DistributionInfo.displayName = 'DistributionInfo';

    return (
      <StyledContainer ref={ref}>
        <StyledBackgroundImageContainer>
          <StyledDisitributionInfoContainer id="distribution-info">
            <Header />
            <FeaturesContainer />
          </StyledDisitributionInfoContainer>
          {customFooter}
        </StyledBackgroundImageContainer>
      </StyledContainer>
    );
  }
);

export default DistributionInfo;
